import { useState, useCallback } from 'react';
import { ModalPrototype } from '@/components/prototypes/ModalPrototype';
import { MOCK_GAME_STATE, MOCK_TEAMS, MOCK_HOLES } from '@/lib/mockGameData';
import type { HoleScore } from '@/lib/golfEngine';
import { Link } from 'wouter';
import { ArrowLeft } from 'lucide-react';

export default function Prototypes() {
  const [scores, setScores] = useState<HoleScore[]>(() => [...MOCK_GAME_STATE.scores]);

  const handleScoreChange = useCallback((playerId: string, holeNumber: number, grossScore: number | null) => {
    setScores((prev) =>
      prev.map((s) => {
        if (s.playerId === playerId && s.holeNumber === holeNumber) {
          return { ...s, grossScore, netScore: grossScore !== null && s.receivesStroke ? grossScore - 1 : grossScore };
        }
        return s;
      })
    );
  }, []);

  return (
    <div className="flex flex-col h-screen max-w-lg mx-auto bg-background" data-testid="prototypes-page">
      <div className="flex items-center gap-2 px-4 py-3 border-b bg-background">
        <Link href="/" className="inline-flex items-center justify-center min-w-[44px] min-h-[44px]" data-testid="link-back-home">
          <ArrowLeft className="w-5 h-5" />
        </Link>
        <h1 className="text-lg font-bold">Scorecard Prototype</h1>
      </div>

      <div className="flex-1 min-h-0 overflow-y-auto">
        <ModalPrototype holes={MOCK_HOLES} teams={MOCK_TEAMS} scores={scores} onScoreChange={handleScoreChange} />
      </div>
    </div>
  );
}
